import { createFileRoute, redirect } from '@tanstack/react-router';

import { LandingPage } from '@/features/landing';

export const Route = createFileRoute('/')({
  component: LandingPage,
  beforeLoad: () => {
    const token = localStorage.getItem('access_token');
    if (token) {
      throw redirect({ to: '/patients' });
    }
  },
});
